import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';
import ContextProvider from 'common/contexts/crud';

const ProductContext = createContext();

export const ProductsProvider = ({ children }) => (
  <ContextProvider url="products" context={ProductContext}>{children}</ContextProvider>
);

ProductsProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

const useProduct = () => useContext(ProductContext);

export default useProduct;
